<template >
    <div class="Today">
        Today - сегодня
    </div>
</template>
<script>
export default {
    name: 'Today'
}
</script>
<style lang="">
    
</style>